export const navigationRoutes = {
  login: '/login',
  signUp: '/sign-up',
  dashboard: '/dashboard',
  userManagement: '/user-management',
  library: '/library',
  contacts: '/contacts',
  clients: '/clients',
  SMTPLog: '/smtp-log',
  promotions: '/promotions',
  webinars: '/webinars',
  profile: '/profile',
  addressBook: '/address-book',
  projects: '/projects',
  residentialById: (id: string) => `/projects/${id}`,
  buildings: '/buildings',
  units: '/units',
  companies: '/companies',
  complexInfrastructure: '/complex-infrastructure',
  photos: '/photos',
  wizard: '/wizard',
  authorizationLog: '/authorization-log',
}
